import { useEffect, useState } from 'react';
import type { CifrasIndicador, ConsultaCifras } from '../../api/ops/indicadores';
import type { Operaciones } from '../../api/operaciones';

/** Las cifras de un indicador con `queryIndicator` (se vuelven a pedir si cambia la consulta). `null` mientras llegan. */
export function useCifras(ops: Operaciones, negocio: string, codigo: string | null, consulta: ConsultaCifras | null): { cifras: CifrasIndicador | null; error: unknown } {
    const [estado, setEstado] = useState<{ firma: string; cifras: CifrasIndicador | null; error: unknown }>({ firma: '', cifras: null, error: null });
    const firma = codigo === null || consulta === null ? '' : `${codigo}|${JSON.stringify(consulta)}`;

    useEffect(() => {
        if (firma === '' || codigo === null || consulta === null) {
            return;
        }
        let vivo = true;
        ops.queryIndicator(negocio, codigo, consulta)
            .then((cifras) => {
                if (vivo) {
                    setEstado({ firma, cifras, error: null });
                }
            })
            .catch((error: unknown) => {
                if (vivo) {
                    setEstado({ firma, cifras: null, error });
                }
            });
        return () => {
            vivo = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- la firma resume el código y la consulta
    }, [ops, negocio, firma]);

    return estado.firma === firma ? { cifras: estado.cifras, error: estado.error } : { cifras: null, error: null };
}
